import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner, Table } from 'reactstrap';
import AsyncSelect from 'react-select/async';
import { customSelectStyles, selectThemeColors } from '../../modules/commonModel/Utils';
import { Controller, useForm } from 'react-hook-form';
import { CustomerService } from '../../modules/Services/Customers';
import { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import Papa from 'papaparse';
import { JobService } from '../../modules/Services/Job';
import toast from 'react-hot-toast';

function ImportBookingModal({ openImportModal, setOpenImportModal, setRenderElementService, setCurrentPage }) {
    const { control, handleSubmit, setValue, formState: { errors } } = useForm({
        defaultValues: {
            customer: '',
            bill_to: '',
            charge_type: 'price_by_job',
            import_type: 'import_into_one_booking'
        }
    });
    const [csvData, setCsvData] = useState({ headerData: null, previewData: null, AllCsvData: null })
    const [csvHeader, setCsvHeader] = useState(null)
    const [bookingColumnHeader, setBookingColumnHeader] = useState(null)
    const [loader, setLoader] = useState(false)
    const entity_id = localStorage.getItem('entity_id');
    const [billTo, setBillTo] = useState(null)
    let customerTimeoutId: ReturnType<typeof setTimeout> | null = null;

    const chargeTypeOption = [
        { value: 'price_by_job', label: 'Price by Booking' },
        { value: 'price_by_job_legs', label: 'Price by Jobs(s)' }
    ];

    const importTypeOption = [
        { value: 'import_into_one_booking', label: 'Import into one booking' },
        { value: 'new_booking_per_job', label: 'New booking per job' }
    ]

    const loadOptions = (inputValue: any, callback: any) => {
        if (customerTimeoutId) {
            clearTimeout(customerTimeoutId);
        }
        customerTimeoutId = setTimeout(() => {
            const obj = {
                getall: 1,
                fields: 'id,customer_name',
                customer_name: inputValue
            }
            CustomerService.getCustomerList(entity_id, obj)
                .then((res: any) => {
                    callback(res?.data?.response?.map((item: any) => {
                        return { value: item?.id, label: item?.customer_name }
                    }))
                })
                .catch(err => console.log(err?.response?.data?.message))
        }, 1000)
    }

    const onSubmit = (data: any) => {
        setLoader(true)

        const mappedObj: any = {};
        if (csvHeader === null) return;

        for (const [key, value] of Object.entries(csvHeader)) {
            mappedObj[key] = (value as { value: any })?.value;
        }

        const payload = {
            client_id: data.customer?.value,
            bill_to: data?.bill_to?.value,
            charge_type: typeof data?.charge_type === 'object' ? data?.charge_type?.value : data?.charge_type,
            import_type: typeof data?.import_type === 'object' ? data?.import_type?.value : data?.import_type,
            mappedFields: mappedObj,
            parsedData: csvData?.AllCsvData
        }

        JobService.importBookingData(entity_id, payload)
            .then((res: any) => {
                toast.success(res?.data?.message)
                setOpenImportModal(false)
                setCurrentPage(1)
                setRenderElementService(1)
            })
            .catch((err: any) => {
                toast.error(err?.response?.data?.message)
            })
            .finally(() => setLoader(false))
    }

    const handleFileChange = (e: any) => {
        if (e.target.files.length) {
            const inputFile = e.target.files[0];
            Papa.parse(inputFile, {
                header: true,
                skipEmptyLines: true,
                complete: function (results: any) {

                    const newHeader = [];
                    results?.meta?.fields?.filter((item: any) => {
                        if (item == '' || item.startsWith('_')) console.log('header not found 72', item)
                        else newHeader.push(item);
                    })
                    newHeader?.map((item: any) => {
                        handleHeaderChange(item, { value: "none", label: "Do not import" })
                    })

                    const previewData = [];
                    for (let index = 0; index < results?.data?.length; index++) {
                        if (index === 2) break;
                        const item = results?.data[index];
                        const newRow = {};
                        for (let key in item) {
                            if (key == '' || key.startsWith('_')) console.log('header not found 82')
                            else newRow[key] = item[key];
                        }
                        previewData.push(newRow);
                    }
                    setCsvData({ headerData: newHeader, previewData: previewData, AllCsvData: results?.data })
                }
            });
        }
    }

    const getBookingColumnHeaderList = () => {
        JobService.getBookingColumnHeader(entity_id)
            .then((res: any) => {
                setBookingColumnHeader(res?.data?.response)
            })
            .catch((err: any) => {
                console.log('error booking header', err?.response?.data?.message)
            })
    }

    useEffect(() => {
        if (openImportModal) {
            getBookingColumnHeaderList()
        } else {
            setCsvData({ headerData: null, previewData: null, AllCsvData: null })
            setCsvHeader(null)
            setBillTo(null)
        }
    }, [openImportModal])

    const handleHeaderChange = (item: any, value: any) => {
        setCsvHeader((pre: any) => ({ ...pre, [item]: value }))
    }

    return (
        <Modal isOpen={openImportModal} toggle={() => setOpenImportModal(false)} className="modal-dialog-centered modal-xl">
            <Form onSubmit={handleSubmit(onSubmit)}>
                <ModalHeader className='d-flex justify-content-center p-4'>
                    Import Booking
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col xs={3}>
                            <Label className='form-label' for='status'>Client</Label>
                            <Controller
                                name='customer'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=''
                                render={({ field: { onChange } }) =>
                                    <AsyncSelect
                                        isClearable={true}
                                        className='react-select w-100'
                                        classNamePrefix='select'
                                        placeholder='Select Client..'
                                        isRtl={false}
                                        name='callback-react-select'
                                        theme={selectThemeColors}
                                        styles={customSelectStyles(null)}
                                        loadOptions={loadOptions}
                                        cacheOptions
                                        onChange={(data: any) => {
                                            onChange(data)
                                            setValue('bill_to', data)
                                            setBillTo(data)
                                        }}
                                    />
                                }
                            />
                            {errors.customer && (<small className="text-danger ml-2 ">Customer is a required field</small>)}
                        </Col>
                        <Col xs={3}>
                            <Label className='form-label' for='status'>Bill To</Label>
                            <Controller
                                name='bill_to'
                                control={control}
                                rules={{ required: false }}
                                defaultValue=''
                                render={({ field: { onChange } }) =>
                                    <AsyncSelect
                                        isClearable={true}
                                        className='react-select w-100'
                                        classNamePrefix='select'
                                        placeholder='Select Client..'
                                        isRtl={false}
                                        name='callback-react-select'
                                        theme={selectThemeColors}
                                        styles={customSelectStyles(null)}
                                        loadOptions={loadOptions}
                                        cacheOptions
                                        value={billTo}
                                        onChange={(data: any) => {
                                            onChange(data)
                                            setBillTo(data)
                                        }}
                                    />
                                }
                            />
                            {errors.bill_to && (<small className="text-danger ml-2 ">Bill to is a required field</small>)}
                        </Col>
                        <Col md='3'>
                            <Label className='form-label' for='status'>Charge Type</Label>
                            <Controller
                                name='charge_type'
                                control={control}
                                rules={{ required: false }}
                                render={({ field }) =>
                                    <ReactSelect
                                        {...field}
                                        isClearable={false}
                                        className='react-select'
                                        classNamePrefix='select'
                                        theme={selectThemeColors}
                                        styles={customSelectStyles(null)}
                                        options={chargeTypeOption}
                                        value={chargeTypeOption.find(option => option.value === field.value)}
                                        onChange={(data: any) => {
                                            field.onChange(data)
                                        }}
                                    />
                                }
                            />
                        </Col>
                        <Col md='3'>
                            <Label className='form-label' for='status'>Import Type</Label>
                            <Controller
                                name='import_type'
                                control={control}
                                rules={{ required: false }}
                                render={({ field }) =>
                                    <ReactSelect
                                        {...field}
                                        isClearable={false}
                                        className='react-select'
                                        classNamePrefix='select'
                                        theme={selectThemeColors}
                                        styles={customSelectStyles(null)}
                                        options={importTypeOption}
                                        value={importTypeOption.find(option => option.value === field.value)}
                                        onChange={(data: any) => {
                                            field.onChange(data)
                                        }}
                                    />
                                }
                            />
                        </Col>
                    </Row>
                    <Row className='my-10'>
                        <div>
                            <Input
                                type='file'
                                accept='.csv, .xlsx, .xls'
                                onChange={handleFileChange}
                            />
                        </div>
                    </Row>
                    <Table responsive bordered>
                        <thead className='sticky-header'>
                            <tr style={{ fontWeight: '500' }}>
                                {csvData?.headerData?.map((item: any, index: any) => {
                                    return (
                                        <th className='ps-3 fw-bold' key={index}>
                                            {item}
                                        </th>
                                    )
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {csvData?.previewData?.map((item: any, i: any) => {
                                return (
                                    <tr key={i} style={{ borderBottom: '1px solid rgba(0, 0, 0, .12)' }}>
                                        {csvData?.headerData?.map((header: any, hIndex: any) => {
                                            return (
                                                <td className='ps-3' key={hIndex}>
                                                    <span className='fs-7'>
                                                        {item?.[header]}
                                                    </span>
                                                </td>
                                            )
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>

                    <Row>
                        <Col className='col-6' style={{ maxHeight: '300px', overflow: 'scroll' }}>
                            {csvData?.headerData?.map((item: any, index: any) => {
                                return (
                                    <Row key={index} className='my-3'>
                                        <Col md='6'>
                                            <Input type='text' value={item} />
                                        </Col>
                                        <Col md='6'>
                                            <ReactSelect
                                                isClearable={false}
                                                className='react-select'
                                                classNamePrefix='select'
                                                theme={selectThemeColors}
                                                styles={customSelectStyles(null)}
                                                menuPlacement="auto"
                                                menuPortalTarget={document.body} // Render dropdown in a portal                                                    
                                                options={bookingColumnHeader}
                                                value={csvHeader[item]}
                                                formatOptionLabel={(e) => (
                                                    
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '1.1rem' }}>
                                                      <span>{e.label}</span>
                                                      <span style={{ opacity: 0.5, fontSize: '1rem' }}>-{e.type}</span>
                                                    </div>
                                                    
                                                  )}
                                                onChange={(data: any) => {
                                                    handleHeaderChange(item, data)
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                )
                            })}
                        </Col>
                    </Row>

                </ModalBody>
                <ModalFooter className='d-flex justify-content-end p-4'>
                    <Button size='sm' type="button" color="secondary" onClick={() => setOpenImportModal(false)}>
                        Close
                    </Button>
                    <Button size='sm' type="submit" color="primary" disabled={loader || csvHeader == null}>
                        {loader ? <Spinner size='sm' /> : 'Import'}
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    )
}

export default ImportBookingModal